import React, { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import { API, fmtDate } from "../../lib/api";
import { useLang } from "../../lib/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

const ENTITIES = ["loan", "repayment", "customer", "item", "staff", "profile", "payment", "backup"];

export default function Audit() {
  const { t } = useLang();
  const [logs, setLogs] = useState(null);
  const [entity, setEntity] = useState("all");

  useEffect(() => {
    API.get("/shop/audit-logs", { params: entity !== "all" ? { entity } : {} })
      .then((r) => setLogs(r.data)).catch(() => setLogs([]));
  }, [entity]);

  return (
    <div data-testid="audit-page">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold text-slate-900 flex items-center gap-2">
          <ScrollText className="h-7 w-7 text-emerald-600" />{t("audit.title")}
        </h1>
        <Select value={entity} onValueChange={setEntity}>
          <SelectTrigger data-testid="audit-entity-filter" className="w-44 bg-white"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white">
            <SelectItem value="all">{t("audit.all")}</SelectItem>
            {ENTITIES.map((e) => <SelectItem key={e} value={e} data-testid={`audit-filter-${e}`}>{t(`audit.entity_${e}`)}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t("common.date")}</TableHead>
              <TableHead>{t("audit.user")}</TableHead>
              <TableHead>{t("audit.action")}</TableHead>
              <TableHead>{t("audit.entity")}</TableHead>
              <TableHead>{t("audit.details")}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {!logs && <TableRow><TableCell colSpan={5} className="text-center text-slate-500 py-10">{t("common.loading")}</TableCell></TableRow>}
            {logs?.length === 0 && (
              <TableRow><TableCell colSpan={5} className="text-center text-slate-500 py-10">{t("audit.empty")}</TableCell></TableRow>
            )}
            {logs?.map((l) => (
              <TableRow key={l.id} data-testid={`audit-row-${l.id.slice(0, 8)}`}>
                <TableCell className="font-mono text-xs whitespace-nowrap">{fmtDate(l.created_at)}</TableCell>
                <TableCell>
                  <div className="text-sm font-medium">{l.user_name || l.user_email}</div>
                  <div className="text-xs text-slate-400">{t(`role.${l.user_role}`)}</div>
                </TableCell>
                <TableCell>
                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-slate-100 text-slate-700">{l.action}</span>
                </TableCell>
                <TableCell className="text-sm">{t(`audit.entity_${l.entity}`)}</TableCell>
                <TableCell className="text-sm text-slate-500">{l.details || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
